import { GeoTargetType } from 'types';

export const MIN_QUERY_TERM_LENGTH = 2;

export const targetTypeTranslationMap = {
  [GeoTargetType['Airport']]: 'Flughafen',
  [GeoTargetType['Canton']]: 'Kanton',
  [GeoTargetType['City Region']]: 'Stadt Region',
  [GeoTargetType['City']]: 'Ort',
  [GeoTargetType['Country']]: 'Land',
  [GeoTargetType['County']]: 'Landkreis',
  [GeoTargetType['District']]: 'Bezirk',
  [GeoTargetType['Municipality']]: 'Gemeinde',
  [GeoTargetType['Neighborhood']]: 'Umgebung',
  [GeoTargetType['Postal Code']]: 'PLZ',
  [GeoTargetType['Province']]: 'Provinz',
  [GeoTargetType['Region']]: 'Bezirk',
  [GeoTargetType['State']]: 'Stadt',
  [GeoTargetType['Department']]: 'Abteilung',
};
